export default {
	'dashboard.SalesCard.today': 'Today',
	'dashboard.SalesCard.thisWeek': 'This Week',
	'dashboard.SalesCard.thisMonth': 'This Month',
	'dashboard.SalesCard.thisYear': 'This Year',
	'dashboard.SalesCard.sales': 'Sales',
	'dashboard.SalesCard.salesVolume': 'Sales Volume',
	'dashboard.SalesCard.salesRank': 'Sales Rank',
	'dashboard.SalesCard.views': 'Profit',
	'dashboard.SalesCard.viewsVolume': 'Visits',
	'dashboard.SalesCard.viewsRank': 'Profit Rank',
	'dashboard.SalesCard.storeNumber': 'Store No. {number}',
	// Tooltip labels
	'dashboard.SalesCard.tooltip.sales': 'Sales Volume',
	'dashboard.SalesCard.tooltip.visits': 'Visits',
};
